import { LOG_OUT_API } from "../../constants/api";
import axios from "../fetch/fetch";

export const logoutAPI = async (): Promise<void> => {
  await axios.post(LOG_OUT_API);
};
